import { Head, Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

interface Patient {
  id: number
  first_name: string
  last_name: string
  birth_date: string
  gender: string
}

interface IndexProps {
  patients: Patient[]
}

export default function Index({ patients }: IndexProps) {
  return (
    <div className="container mx-auto py-8">
      <Head title="Patients" />
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Patients</h1>
        <Button asChild>
          <Link href="/patients/new">Nouveau Patient</Link>
        </Button>
      </div>

      <div className="border rounded-md">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nom</TableHead>
              <TableHead>Prénom</TableHead>
              <TableHead>Date de naissance</TableHead>
              <TableHead>Genre</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {patients.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center h-24 text-muted-foreground">
                  Aucun patient trouvé.
                </TableCell>
              </TableRow>
            ) : (
              patients.map((patient) => (
                <TableRow key={patient.id}>
                  <TableCell className="font-medium">{patient.last_name}</TableCell>
                  <TableCell>{patient.first_name}</TableCell>
                  <TableCell>{patient.birth_date}</TableCell>
                  <TableCell>{patient.gender}</TableCell>
                  <TableCell className="text-right">
                    <Button variant="ghost" asChild>
                      <Link href={`/patients/${patient.id}`}>Voir</Link>
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
